// Evidence card — Sharp Cut panel: white surface with 2px ink border, hard offset shadow.
// Badge uses the "cut" number tag (green = savings, ink = growth, muted = directional).
export const EvidenceCard = ({ id, title, badge, badgeColor, tag, footnote, children }) => {
  // badgeColor mapping (legacy hex from callers → tag variant)
  let badgeCls = "ss-cut-tag";
  if (badgeColor === "#0d0d0d" || badgeColor === "#185FA5" || badgeColor === "#1A1A1A") badgeCls += " ss-cut-tag--ink";
  else if (badgeColor === "#96a09a" || badgeColor === "#808080") badgeCls += " ss-cut-tag--muted";
  // default is green

  return (
    <section
      id={`sec-${id}`}
      data-testid={`evidence-${id}`}
      className="ss-panel p-6 sm:p-10 scroll-mt-24"
    >
      <div className="flex items-start justify-between gap-4 flex-wrap mb-4">
        <div>
          {tag && (
            <p className="ss-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-[color:var(--grey)] mb-2">
              {tag}
            </p>
          )}
          <h3 className="font-display text-2xl sm:text-3xl text-[color:var(--ink)]">{title}</h3>
        </div>
        {badge && (
          <span className={badgeCls} data-testid={`evidence-${id}-badge`}>
            {badge}
          </span>
        )}
      </div>
      {children}
      {footnote && (
        <div className="mt-6 pt-4 border-t border-[color:var(--hairline)]">
          <p className="ss-mono text-[10px] font-semibold uppercase tracking-[0.16em] text-[color:var(--grey)] mb-1">
            Assumption
          </p>
          <p className="text-xs text-[color:var(--grey)] leading-relaxed">{footnote}</p>
        </div>
      )}
    </section>
  );
};

// Plain informational list — one line per section that couldn't be scored because
// there was no matching activity in the bulk file. No CTA, no "upload another file".
export const LockedSectionsList = ({ items, titles }) => {
  if (!items || items.length === 0) return null;
  return (
    <section className="ss-panel p-6 sm:p-8" data-testid="locked-sections-list">
      <p className="ss-mono text-[10px] font-semibold uppercase tracking-[0.18em] text-[color:var(--grey)] mb-4">
        Sections we couldn't score
      </p>
      <ul className="divide-y divide-[color:var(--hairline)]">
        {items.map((l) => (
          <li key={l.id} className="py-3 flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-3" data-testid={`locked-${l.id}`}>
            <span className="font-semibold text-[color:var(--ink)] text-sm sm:min-w-[200px]">
              {titles[l.id] || l.id}
            </span>
            <span className="text-sm text-[color:var(--grey)] leading-relaxed">{l.reason}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export const SubHead = ({ children }) => (
  <h4 className="ss-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-[color:var(--ink)] mt-8 mb-3">
    {children}
  </h4>
);
